"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAYA_TAG_MAP = exports.NATIF_TAG_MAP = exports.NATIF_SENDER_TAG_MAP = exports.NATIF_DOCUMENT_TAG_MAP = exports.NATIF_N26_DOCUMENT_TAG_MAP = exports.NATIF_GENERIC_DOCUMENT_TAG_MAP = void 0;
exports.NATIF_GENERIC_DOCUMENT_TAG_MAP = Object.freeze({
    abrechnung: 'abrechnung',
    angebot: 'angebot',
    ausweisdokument: 'ausweisdokument',
    bankkarte: 'bankkarte',
    bericht: 'bericht',
    bescheid: 'bescheid',
    bescheinigung: 'bescheinigung',
    bestellbestaetigung: 'bestellbestätigung',
    bussgeld: 'bussgeld',
    dialogpost: 'dialogpost',
    einladung: 'einladung',
    gehalt: 'gehalt',
    gutachten: 'gutachten',
    gutschrift: 'gutschrift',
    hotelrechnung: 'hotelrechnung',
    immatrikulationsbescheinigung: 'immatrikulationsbescheinigung',
    katalog: 'katalog',
    'kfz-schein': 'kfz-schein',
    konto: 'konto',
    kontoauszug: 'kontoauszug',
    kundenkarte: 'kundenkarte',
    lieferschein: 'lieferschein',
    persoenlich: 'persönlich',
    postruecklaeufer: 'postrückläufer',
    quittung: 'quittung',
    urkunde: 'urkunde',
    versichertenkarte: 'versichertenkarte',
    versicherungsschein: 'versicherungsschein',
    vertrag: 'vertrag',
    warensendung: 'warensendung',
});
exports.NATIF_N26_DOCUMENT_TAG_MAP = Object.freeze({
    achtung: 'achtung',
    bargeld_scheck: 'bargeld/scheck',
    basiskonto: 'basiskonto',
    benachrichtigung: 'benachrichtigung',
    blacklist: 'blacklist',
    'client-ident': 'client ident.',
    erbschein: 'erbschein',
    ermittlungsverfahren: 'ermittlungsverfahren',
    'ermittlungsverfahren-erinnerung': 'ermittlungsverfahren/erinnerung',
    forderungsaufstellung: 'forderungsaufstellung',
    gerichtsdokumente: 'gerichtsdokumente',
    hinterlegung: 'hinterlegung',
    insolvenzsache: 'insolvenzsache',
    irrlaufer: 'irrläufer',
    kreditabloesung: 'kreditablösung',
    kuendigung: 'kündigung',
    legal: 'legal',
    mahnung: 'mahnung',
    nachlass: 'nachlass',
    pfaendung: 'pfändung',
    pfaendung_bescheinigung: 'pfändung/bescheinigung',
    rechnung: 'rechnung',
    rentenrueckforderung: 'rentenrückforderung',
    rueckbuchung: 'rückbuchung',
    unbedenklichkeitsbescheinigung: 'unbedenklichkeitsbescheinigung',
    vergleich: 'vergleich',
    vollmacht: 'vollmacht',
    vorladung: 'vorladung',
});
exports.NATIF_DOCUMENT_TAG_MAP = Object.freeze({
    ...exports.NATIF_GENERIC_DOCUMENT_TAG_MAP,
    ...exports.NATIF_N26_DOCUMENT_TAG_MAP,
});
exports.NATIF_SENDER_TAG_MAP = Object.freeze({
    anwalt: 'anwalt',
    apotheke: 'apotheke',
    arbeitgeber: 'arbeitgeber',
    arbeitsagentur: 'arbeitsagentur',
    arzt: 'arzt',
    bank: 'bank',
    bildungseinrichtung: 'bildungseinrichtung',
    caya: 'caya',
    dienstleister: 'dienstleister',
    'einzel-und-grosshandel': 'einzel- und grosshandel',
    energie: 'energie',
    familienkasse: 'familienkasse',
    finanzamt: 'finanzamt',
    finanzdienstleister: 'finanzdienstleister',
    gemeinnuetzig: 'gemeinnützig',
    genossenschaft: 'genossenschaft',
    gericht: 'gericht',
    gewerkschaft: 'gewerkschaft',
    immobilien: 'immobilien',
    inkasso: 'inkasso',
    jobcenter: 'jobcenter',
    kammer: 'kammer',
    kommunikation: 'kommunikation',
    krankenkasse: 'krankenkasse',
    kulturgemeinschaft: 'kulturgemeinschaft',
    mobilitaet: 'mobilität',
    notar: 'notar',
    'oeffentliche-verwaltung': 'öffentliche verwaltung',
    'politische-partei': 'politische partei',
    polizei: 'polizei',
    postdienstleister: 'postdienstleister',
    privatperson: 'privatperson',
    rentenversicherung: 'rentenversicherung',
    rundfunk: 'rundfunk',
    staatsanwaltschaft: 'staatsanwaltschaft',
    steuerberater: 'steuerberater',
    unterhaltung: 'unterhaltung',
    verband: 'verband',
    verlag: 'verlag',
    versandhandel: 'versandhandel',
    versicherung: 'versicherung',
    zoll: 'zoll',
});
exports.NATIF_TAG_MAP = Object.freeze({
    ...exports.NATIF_DOCUMENT_TAG_MAP,
    ...exports.NATIF_SENDER_TAG_MAP,
});
exports.CAYA_TAG_MAP = Object.fromEntries(Object.entries(exports.NATIF_TAG_MAP).map(([key, value]) => [value, key]));
//# sourceMappingURL=constants.js.map